import { render, staticRenderFns } from "./MatchFieldsNavigationBtn.vue?vue&type=template&id=29cbea54&"
import script from "./MatchFieldsNavigationBtn.vue?vue&type=script&lang=ts&"
export * from "./MatchFieldsNavigationBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports